export function addSessionMessage(almeState, platformSessionId, platformMessageKey, platformMessage) {
    let sessionMessages = almeState.sessionMessages && Object.assign({}, almeState.sessionMessages);
    if (sessionMessages && sessionMessages.messages && (sessionMessages.sessionId === platformSessionId)) {
        sessionMessages.messages[platformMessageKey] = platformMessage;
    }
    else {
        const messages = { [platformMessageKey]: platformMessage };
        sessionMessages = {
            sessionId: platformSessionId,
            messages,
        };
    }
    return sessionMessages;
}
export function setEchatSessionInfoCalled(almeState, sessionId) {
    let sessionMessages = almeState.sessionMessages && Object.assign({}, almeState.sessionMessages);
    if ((!sessionMessages || sessionMessages.sessionId !== sessionId) && typeof window.insertEChatSesionInfo === 'function') {
        window.insertEChatSesionInfo();
        sessionMessages = {
            sessionId: sessionId,
            insertEchatSessionInfoCalled: true,
        };
    }
    return sessionMessages;
}
